<template>
	<div class="divcreateorder">
		<createordercompose ref="createordercompose" v-show="type == '进口1'"></createordercompose>
		<haitaopackage ref="haitaopackage" v-if="type=='默认'" :urlparam="pageparam" :curpkval="curpkval" :iscopy="iscopy"></haitaopackage>
	</div>
</template>
<script>
import createordercompose from '@/components/order/createorder_compose.vue';
import haitaopackage from '@/components/haitaoorder/create_haitaopackage.vue';	
export default {
	components: {
		createordercompose,
		haitaopackage
	},
	props: {
		urlparam: {
			type: Object,
			default: {}
		}
	},
	data() {
		return {
			pageparam: {},
			curpkval: '',
			iscopy: 0,
			type: '',
			orderinfo:{}
		};
	},
	mounted() {
		debugger
		if (this.urlparam != undefined) {
			this.pageparam = this.urlparam;
			if (this.urlparam.pkval != undefined) {
				this.curpkval = this.urlparam.pkval;
				if (this.urlparam.iscopy != undefined) {
					this.iscopy = this.urlparam.iscopy;
				}
			}
			if(this.urlparam.orderinfo!=undefined)
				this.orderinfo=this.urlparam.orderinfo;//这个用于从别的功能传值过来，比如报价那边过来，或者转运过来
			if(this.urlparam.l_tablename!=undefined)
				this.type=this.urlparam.l_tablename;
			if (this.type == '进口1') {
				this.$nextTick(function(){
					if (this.$refs.createordercompose != undefined) {
						this.$refs.createordercompose.init({pkval:this.curpkval,iscopy:this.iscopy,orderinfo:this.orderinfo});
					}
				});
			}
			else{
				this.type="默认";
				this.$nextTick(function(){
					if (this.$refs.haitaopackage != undefined) {
						this.$refs.haitaopackage.init();
					}
				});
				
			}
		}
	}
};
</script>
